export default __webpack_public_path__ + "static/media/sl.adea6fae.jpg";